import React, { Component } from 'react'
import { connect } from 'react-redux';
import '../../App.css';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

import DialogAction from '../../componets/DialogAction.jsx';
import DialogPanel from '../../componets/DialogPanel.jsx';

import * as RefundActions from '../../actions/Actions_RefundManager';

import RefundReasonsCard from './RefundReasonsCard';
import RefundReasonsListPanel from './RefundReasonsListPanel';
import { init_refund } from '../../constant/initState/initRefund';

import { InitWaitingTime, SetStateWithTime, SetStateWithObject } from '../../common/SetTime.js';

let RefundReasonsList = [];
let waitingTime = true;
const _height = (window.innerHeight - 130);

class RefundReasonsManage extends Component {
    state = { isLoading: true, msgError: undefined, dialogType: undefined, }
    constructor(props) {
        let error = null;
        super(props);
        this.state = {
            RefundInfo: undefined,
            isCreate: false,
            isEdit: false,
            isView: false,
        }
        this.props.getRefundReasonsList({ num_limit: 10 });
    }

    componentWillReceiveProps(nextProps) {
        const { RefundManager } = nextProps;
        if (!!RefundManager) {

            const { actions, data } = RefundManager.REFUND_REDUCER;

            switch (actions) {
                case RefundActions.GET_REFUND_REASONS_SUCCESS:
                    {
                        RefundReasonsList = data.result;
                        SetStateWithTime(this, waitingTime);
                    } break;
                case RefundActions.GET_REFUND_REASONS_FAILURE:
                    {
                        SetStateWithTime(this, waitingTime);
                    } break;
            }
        }
    }

    render() {
        const { isLoading, isCreate } = this.state;
        return (
            <div className="App">
                {(isCreate) && <DialogAction Active={isCreate} OnClose={this.onClosePanel} AcrionCom={this.createRefund()} />}
                {(isLoading) && <DialogPanel Active={isLoading} />}
                <List style={{ width: '100%', position: 'relative', overflow: 'auto' }}>
                    <div style={{ display: 'inline-block' }}>
                        {this.contentPanel()}
                    </div>
                </List>
            </div>
        )
    }
    contentPanel() {
        return (
            <div style={{ height: '600px', width: '100%', maxWidth: '1024px', }}>
                <RefundReasonsListPanel
                    RefundReasonsList={RefundReasonsList}
                    CreatePanel={this.onCreatePanel(this.state.isCreate)}
                    EditInfo={this.editPanel()}
                    ViewInfo={this.viewInfo()} />
            </div>)
    }

    createRefund = () => {
        const { isEdit, RefundInfo, isView } = this.state;
        return (
            <RefundReasonsCard
                RefundReasonsList={RefundReasonsList}
                onChangeLanguage={this.onChangeLanguage}
                isEdit={isEdit}
                isView={isView}
                RefundInfo={RefundInfo}
                onClosePanel={this.onClosePanel} />
        )
    }

    onCreatePanel = (_isActive) => () => (this.setState({ isCreate: !_isActive, isEdit: false, isView: false, RefundInfo: { ...init_refund } }));
    onClosePanel = () => (this.setState({ isCreate: false, isEdit: false, isView: false, RefundInfo: undefined, }));
    onCloseDialog = () => (this.setState({ isLoading: false, msgError: undefined, dialogType: undefined }));

    onChangeLanguage = (_language) => {
        const { page } = RefundReasonsList;
        this.props.getRefundReasonsList({ page: page, num_limit: 10, language: _language });
    }

    editPanel = () => (RefundInfo) => {
        this.setState({
            isCreate: true,
            isEdit: true,
            isView: false,
            RefundInfo,
        })
    }

    viewInfo = () => (RefundInfo) => {
        this.setState({
            isCreate: true,
            isView: true,
            RefundInfo,
        })
    }

}
function mapStateToProps(state, ownProps) { return { ...state } }

function mapDispatchToProps(dispatch) {
    return {
        getRefundReasonsList: (_keyword, _filter) => {
            InitWaitingTime();
            dispatch(RefundActions.getRefundReasonsList(_keyword, _filter));
        }
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(RefundReasonsManage);